import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash"
import { Button, Grid, Typography, Box, TextField, } from '@mui/material'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { selectParticipantDemographicsById } from '../../../reducers/admincenter_participantdemographics';
import { fetchParticipantInvites, participantinviteClear } from '../../../reducers/admincenter_participantinvite';
import { selectErrorMessagesByNegativeCode } from '../../../reducers/reference_errormessages';
import { useLocation } from 'react-router';

/**
 * 
 * {"ModalSendInvite": {
                        "Title": "Send Invite",
                        "EmailToLabel": "To:",
                        "EmailTo": "<<EmailTo>>",
                        "EmailSubjectLabel": "Subject:",
                        "EmailSubject": "Login Instructions for Your Health Risk Assessment",
                        "EmailBodyLabel": "Message:",
                        "EmailBody": "You are invited to take an online health risk assessment (HRA).  Here's what to do next:    1. Click the link below.   2. Set your password.  3. On the login page, enter your username and your password.    The HRA will only take about 10-15 minutes to fill out. Click the login link below to get started!",
                        "AppendedTextLabel": "Appended Text (Read Only)",
                        "AppendedText": "<br/><a href=\"[CUSTOMER-SITE-DOMAIN-LEAVE-THIS-ALONE!]/WsWebAppWellSuite/index.html[QUERYSTRING-PARAMS-LEAVE-THIS-ALONE!]\" title=\"\" target=\"_blank\">Login</a>",
                        "SendLabel": "Send",
                        "CancelLabel": "Cancel",
                        "CloseLabel": "Close",
                        "SaveAsTemplateLabel": "Save as group template "
                    }} props 
 *  
 */
const ParticipantInvite = (props) => {
    const dispatch = useDispatch()
    const location = useLocation()

    const Participant = props.Participant
    const { user: currentUser } = useSelector((state) => state.auth);
    const ParticipantAdditionalInfo = useSelector(state => selectParticipantDemographicsById(state, Participant.ParticipantGuid))
    const CombinedData = ({ ...Participant, ...ParticipantAdditionalInfo })
    const [messageState, setMessageState] = useState(
            { EmailTo: CombinedData.Email
                , EmailSubject: props.ParticipantTab && props.ParticipantTab.ModalSendInvite && props.ParticipantTab.ModalSendInvite.EmailSubject
                , EmailBody: props.ParticipantTab && props.ParticipantTab.ModalSendInvite && props.ParticipantTab.ModalSendInvite.EmailBody
                , EmailFrom: "" 
            })

            
    const participantInviteStatus = useSelector(state => state.participantinvites.status)
    const participantInviteError = useSelector(state => state.participantinvites.error)
    const ErrorMessage = useSelector(state => selectErrorMessagesByNegativeCode(state, participantInviteError && participantInviteError.ErrorID))
    const [isError, setIsError] = useState(false)

    useEffect(() => {
        if (participantInviteStatus === "success") {

            handleCancel()
        }
        else if (participantInviteStatus === "failed") {
            setIsError(true)
        }
    }, [participantInviteStatus])

    const handleSendInvite = () => {
        const appendedMessage = {...messageState, EmailBody: messageState.EmailBody + props.ParticipantTab.ModalSendInvite.AppendedText}
        dispatch(fetchParticipantInvites({ ...appendedMessage, authToken: currentUser.AuthToken, ParticipantId_Guid: CombinedData.ParticipantGuid }))

    }

    const handleCancel = () => {
        setIsError(false)
        dispatch(participantinviteClear())
        props.cancelButton()
    }

    function ValidateEmail(input) {
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (input.match(validRegex)) {
            return true;
        } else {
            return false;
        }
    }
    const ValidTo = ValidateEmail(messageState.EmailTo)
    //   const ValidFrom = ValidateEmail(messageState.EmailFrom)
    return (
        <Box>
            <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h4" align="center">Invite Participant</Typography>
                </Grid>
                <Grid item xs={10} md={8}>
                    <TextField
                        error={!ValidTo}
                        helperText={ValidTo ? "" : "Invalid Email"}
                        value={messageState.EmailTo}
                        fullWidth
                        placeholder="To:"
                        label="To:"
                        variant="standard"
                        onChange={(e) => {
                            let temp = { ...messageState }
                            temp.EmailTo = e.target.value
                            setMessageState(temp)
                        }}
                    />
                </Grid>
                {/* <Grid item xs={10} md={8}>
                    <TextField
                        error={!ValidFrom}
                        helperText={ValidFrom ? "" : "Invalid Email"}
                        value={messageState.EmailFrom}
                        fullWidth
                        placeholder="From:"
                        label="From:"
                        variant="standard"
                        onChange={(e) => {
                            let temp = { ...messageState }
                            temp.EmailFrom = e.target.value
                            setMessageState(temp)
                        }}
                    />
                </Grid> */}
                <Grid item xs={10} md={8}>
                    <TextField
                        value={messageState.EmailSubject}
                        fullWidth
                        placeholder="Subject:"
                        label="Subject:"
                        variant="standard"
                        onChange={(e) => {
                            let temp = { ...messageState }
                            temp.EmailSubject = e.target.value
                            setMessageState(temp)
                        }}
                    />
                </Grid>
                <Grid item xs={10} md={8}>
                    <TextField
                        value={messageState.EmailBody}
                        fullWidth
                        placeholder="Message:"
                        label="Message:"
                        variant="outlined"
                        multiline
                        rows={5}
                        onChange={(e) => {
                            let temp = { ...messageState }
                            temp.EmailBody = e.target.value
                            setMessageState(temp)
                        }}
                    />
                </Grid>

                <Grid item xs={12} justifyContent="center">
                    <Grid container direction="row" alignItems="center" justifyContent="center" spacing={2}>
                        <Grid item xs={3}>
                            <Box display="flex" justifyContent="center">
                                <Button fullWidth variant="contained" color="success"
                                    disabled={!ValidTo
                                        //|| !ValidFrom 
                                        || !messageState.EmailSubject
                                        || !messageState.EmailBody}
                                    onClick={() => { handleSendInvite() }}>Send</Button>
                            </Box>
                        </Grid>
                        <Grid item xs={3}>
                            <Box display="flex" justifyContent="center">
                                <Button fullWidth variant="contained" color="error" onClick={() => { handleCancel() }}>Cancel</Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Grid>



                {isError === true && (

                    <Grid item xs={10} md={8}>
                        <Box>
                            <Typography variant="h6" color="error" align="center">
                                {
                                    (ErrorMessage && ErrorMessage.length > 0 && ErrorMessage[0].MessageTypeContent)
                                    ||
                                    (participantInviteError && participantInviteError.ErrorMessage)
                                }
                            </Typography>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </Box>
    )
}

export default ParticipantInvite